import { render, staticRenderFns } from "./DisplaySingleProjectLabel.vue?vue&type=template&id=26a05354&scoped=true&"
import script from "./DisplaySingleProjectLabel.vue?vue&type=script&lang=js&"
export * from "./DisplaySingleProjectLabel.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySingleProjectLabel.vue?vue&type=style&index=0&id=26a05354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a05354",
  null
  
)

export default component.exports